export default class Location {
  partner: string;
  region: string;
  area: string;
  club: string;
  address: {
    line1: string;
    line2?: string;
    city: string;
    state: string;
    stateName: string;
    zip: string;
    lat: number;
    lng: number;
  };
  email?: string;
  phone?: string;
  hours: {
    monday?: string;
    tuesday?: string;
    wednesday?: string;
    thursday?: string;
    friday?: string;
    saturday?: string;
    sunday?: string;
  };

  constructor(props: any) {
    this.partner = props.partner;
    this.region = props.region;
    this.area = props.area;
    this.club = props.club;
    this.address = props.address;
    this.email = props.email;
    this.phone = props.phone;
    this.hours = props.hours;
  }

  getFormattedAddress() {
    return `${this.address.line1},${
      this.address.line2 ? ` ${this.address.line2},` : ''
    } 
    ${this.address.city}, ${this.address.state} ${this.address.zip}`;
  }
}
